/**
 * Navigator 가 만들 URL 의 *키* SSOT — write 측 (Navigator URL 조립) 이 사용.
 *
 * 읽기 측 (페이지 진입 시 search params 검증) 은 `query-schemas.ts` 의 zod schema 가
 * 담당 — `loginSearchSchema` / `unauthorizedSearchSchema` 가 본 키들의 값을 검증
 * 후 typed 형태로 반환한다. write 측이 키를 바꾸면 read schema 도 같이 갱신해야
 * 양면이 일치 (co-location 으로 SSOT 유지: 같은 segment 안 `url-params.ts` +
 * `query-schemas.ts`).
 */
export const NAV_QUERY_KEYS = {
  /** 인증 흐름 redirect 위치 — `/login` / `/error/unauthorized` 공통. URL 키는
   *  camelCase (`redirectUrl`) — URL query 키 camelCase 일관성 정책. TS 식별자도
   *  camelCase (`redirectUrl`). open-redirect + self-loop 방어는
   *  `query-schemas.ts` 의 `redirectUrlField` SSOT. */
  REDIRECT_URL: 'redirectUrl',
  /** 진입 맥락/사유 — `/error/unauthorized`(`UnauthorizedReason`) · `/login`(`LoginReason`)
   *  공유 키. 값 union 은 라우트별로 다르고 화이트리스트 검증은 `query-schemas.ts` 의
   *  `reasonField`(unauthorized)·`loginReasonField`(login) SSOT. */
  REASON: 'reason',
} as const;

/** nav query URL 키 union (`'redirectUrl' | 'reason'`). `buildNavPath` 의 키 제약에 사용. */
export type NavQueryKey = (typeof NAV_QUERY_KEYS)[keyof typeof NAV_QUERY_KEYS];

/**
 * inbound 단기 토큰 키 — works-app WebView 가 진입 URL 에 실어 보내는 읽기 전용 param
 * (`...&t=<단기토큰>`). 우리는 *쓰지* 않고 가드(`consumeInboundToken`)가 읽어 교환 후 제거.
 * `NAV_QUERY_KEYS`(write 측)와 별개 — 방향이 반대(native → web)라 분리. plantId 등 다른
 * param 은 보존하고 `t` 만 strip 한다. 처리 결정 SSOT = ADR `inbound-token-auth`.
 */
export const INBOUND_TOKEN_KEY = 't';
